module.exports = __webpack_public_path__ + "static/media/favicon-32x32.de2929b8.svg";